import classnames from 'classnames';

import styles from './AddButton.module.scss';
import { Props } from './AddButton.types';

/**
 * @deprecated use the following instead:
 * @example import { CircleAdd } from '@randstad-lean-mobile-factory/react-assets/dist/icon';
 *          import { Button } from '@randstad-lean-mobile-factory/react-components-core';
 *
 *          <Button variant="tertiary" size="medium"><CircleAdd /></Button>
 */
export const AddButton = ({ text, className, disabled, icon, ...buttonProps }: Props) => {
  return (
    <button
      className={classnames(styles.container, { [styles.disabled]: disabled }, className)}
      disabled={disabled ?? false}
      {...buttonProps}
    >
      {icon}
      <p className={styles.text}>{text}</p>
    </button>
  );
};
